import { NotificationType } from "./notification-type";

export class NotificationModel {
    //#region Fields

    title: string;
    body: string;
    delay?: number;
    type: NotificationType = NotificationType.Info;

    //#endregion

    //#region Properties

    get isSuccess() {
        return this.type == NotificationType.Success;
    }

    get isInfo() {
        return this.type == NotificationType.Info;
    }

    get isDanger() {
        return this.type == NotificationType.Danger;
    }

    get isWarning() {
        return this.type == NotificationType.Warning;
    }

    //#endregion
}